module.exports = __webpack_public_path__ + "static/media/ru.6e8cc30d.svg";